


import { createUseStyles } from 'react-jss'

export const useStyles = createUseStyles({
    clearIcon: {
        fontSize: "1rem",
    },
    searchField: {
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#E2E8F0",
        },
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
            { borderColor: "#E2E8F0" },

        "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#E2E8F0",
        },
    }
})